module.exports = __webpack_public_path__ + "media/metronic/_theme/media/logos/favicon-6329798aad91752c4c2c9a50549e4384.ico";